import * as l from "../../lib/littlejs.esm";
import { tilesize, tilesheets } from '../const/tiles.ts';
import Globals from "../globals.ts";
const invincibilityDuration = 120;
class Rex extends l.EngineObject {
    constructor(pos) {
        let rexTile = l.tile(0, tilesize, tilesheets.REX_IDLE);
        let rexAndChipTile = l.tile(0, tilesize, tilesheets.REX_IDLE); // Assuming same for now, can be adjusted
        super(pos, l.vec2(1, 1), rexTile, 0, l.hsl(0, 0, 1), 1);
        this.x = 0;
        this.y = 0;
        this.controlling = false;
        this.canJump = true;
        this.jumpCount = 0;
        this.maxJumps = 2;
        this.jumpPressed = false;
        this.chipOnBack = false;
        this.health = 5;
        this.baseColor = l.hsl(1, 1, 1);
        this.grayColor = l.hsl(0, 0, 0.2);
        // Invincibility after taking damage
        this.invincibleTimer = 0;
        this.blinkTick = 0;
        // Animation properties
        this.walkFrame = 0;
        this.walkTimer = 0;
        this.jumpFrame = 0;
        this.jumpTimer = 0;
        this.isJumping = false;
        this.jumpDelayFrames = 0;
        this.jumpDelayMax = 3;
        this.landed = true;
        this.rexTile = rexTile;
        this.rexAndChipTile = rexAndChipTile;
        this.collideTiles = true;
        this.collideSolidObjects = true;
        this.controlling = true;
    }
    update() {
        if (Globals.gameState == 'levelStart') {
            return;
        }
        // Handle invincibility countdown and blinking visual
        if (this.invincibleTimer > 0) {
            this.invincibleTimer--;
            // Toggle twice per 12 frames, so it blinks 5 times per second
            this.blinkTick = (this.blinkTick + 1) % 12;
            const alpha = this.blinkTick < 6 ? 0.2 : 1;
            this.color = new l.Color(this.baseColor.r, this.baseColor.g, this.baseColor.b, alpha);
            if (this.invincibleTimer <= 0) {
                // Restore base color when invincibility ends
                this.color = new l.Color(this.baseColor.r, this.baseColor.g, this.baseColor.b, this.baseColor.a);
                this.blinkTick = 0;
            }
        }
        // If we don't control Rex we gray it out and just update its position with gravity
        if (!this.controlling) {
            // this.color = this.grayColor;
            super.update();
            return;
        }
        this.tileInfo = this.chipOnBack ? this.rexAndChipTile : this.rexTile;
        // Movement controls
        const speed = 0.2;
        const jumpForce = .4;
        let isMoving = false;
        // Movement is disabled for 1 second if we take damage
        if (this.invincibleTimer < invincibilityDuration - 60) {
            // Check if game is in levelStart state - if so, don't allow movement
            if (l.keyIsDown('ArrowLeft') || l.keyIsDown('KeyA')) {
                this.velocity.x = -speed;
                isMoving = true;
                this.mirror = true; // Mirror horizontally when walking left
            }
            else if (l.keyIsDown('ArrowRight') || l.keyIsDown('KeyD')) {
                this.velocity.x = speed;
                isMoving = true;
                this.mirror = false; // No mirror when walking right
            }
            else {
                this.velocity.x *= 0.8; // friction
            }
            // Handle jump
            if ((l.keyIsDown('Space') || l.keyIsDown('ArrowUp')) && this.jumpCount < this.maxJumps && !this.jumpPressed) {
                console.log("JUMP");
                this.velocity.y = jumpForce;
                this.jumpCount++;
                this.jumpPressed = true;
                this.isJumping = true;
                this.landed = false;
            }
            // Reset jump pressed flag when key is released
            if (!(l.keyIsDown('Space') || l.keyIsDown('ArrowUp'))) {
                this.jumpPressed = false;
            }
        }
        // Animation logic
        if (this.isJumping) {
            // Jumping animation sequence
            if (this.velocity.y > 0) {
                // Going up - use frame 3
                this.tileInfo = l.tile(3, tilesize, tilesheets.REX_JUMPING);
            }
            else {
                // In air - use frame 4
                this.tileInfo = l.tile(4, tilesize, tilesheets.REX_JUMPING);
            }
        }
        else if (this.landed && this.jumpFrame < 8) {
            // Landing animation: frames 5, 6, 7
            this.jumpTimer += l.timeDelta;
            if (this.jumpTimer > 0.1) { // Change frame every 0.1 seconds
                this.jumpFrame++;
                this.jumpTimer = 0;
                if (this.jumpFrame <= 7) {
                    this.tileInfo = l.tile(this.jumpFrame, tilesize, tilesheets.REX_JUMPING);
                }
                else {
                    // Reset to idle/walking
                    this.jumpFrame = 0;
                    this.landed = false;
                }
            }
        }
        else if (isMoving) {
            // Walking animation
            this.walkTimer += l.timeDelta;
            if (this.walkTimer > 0.1) { // Change frame every 0.1 seconds
                this.walkFrame = (this.walkFrame + 1) % 6;
                this.walkTimer = 0;
                this.tileInfo = l.tile(this.walkFrame, tilesize, tilesheets.REX_WALKING);
            }
        }
        else {
            // Idle
            this.tileInfo = l.tile(0, tilesize, tilesheets.REX_IDLE);
            this.walkFrame = 0;
            this.walkTimer = 0;
        }
        // Override with chip on back if applicable
        if (this.chipOnBack) {
            // For now, keep the same tile, but this could be adjusted
        }
        // Override with chip on back if applicable
        if (this.chipOnBack) {
            // For now, keep the same tile, but this could be adjusted
        }
        super.update();
    }
    collideWithObject(object) {
        // Reset jump count when colliding with solid objects (ground, platforms, etc.)
        if (object.collideSolidObjects) {
            this.jumpCount = 0;
            if (this.isJumping) {
                this.isJumping = false;
                this.landed = true;
                this.jumpFrame = 5; // Start landing animation from frame 5
            }
        }
        return super.collideWithObject(object);
    }
    collideWithTile(tileData, pos) {
        // Reset jump count when colliding with tiles (ground)
        this.jumpCount = 0;
        if (this.isJumping) {
            this.isJumping = false;
            this.landed = true;
            this.jumpFrame = 5; // Start landing animation from frame 5
        }
        return super.collideWithTile(tileData, pos);
    }
    // If we take damage, we have some invincibility frames, and we
    // are thrown back
    takeDamage(damage, dmgOrigin) {
        if (this.invincibleTimer > 0) {
            return;
        }
        this.health -= damage;
        this.invincibleTimer = invincibilityDuration;
        // Calculate knockback direction from damage origin to player position
        const knockbackDirection = this.pos.subtract(dmgOrigin).normalize();
        const knockbackForce = 0.4;
        this.velocity = this.velocity.add(knockbackDirection.multiply(l.vec2(knockbackForce, knockbackForce)));
    }
}
export default Rex;
